import { motion } from 'framer-motion';

const rooms = [
  {
    label: 'The White Room',
    title: 'Where it begins',
    description: 'Cube, ladder, horse, flowers, storm. The classic reading, and the heart of your portrait.',
    available: true,
  },
  {
    label: 'The First Memory',
    title: 'Your oldest photograph',
    description:
      'Your earliest memory, read the way Alfred Adler read them: as the story you have been telling yourself the longest.',
    available: true,
  },
  {
    label: 'The Table & The Bridge',
    title: 'Coming soon',
    description:
      'A dinner table that seats your family, and a bridge for whatever you are about to cross. The portrait grows with every room.',
    available: false,
  },
];

export default function ManyRooms() {
  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 border-t border-[#e4e1d8]">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-10"
        >
          <h2 className="font-serif font-medium text-3xl sm:text-4xl text-[#1d1f24] mb-3">One portrait, many rooms</h2>
          <p className="text-lg text-[#5d606a] max-w-2xl">
            The cube opens the door. Every test you add sharpens the portrait, and each one takes a few minutes.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {rooms.map((room, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className={`bg-white border border-[#e4e1d8] rounded-xl p-7 shadow-[0_10px_24px_rgba(29,31,36,0.05)] ${
                room.available ? '' : 'opacity-75'
              }`}
            >
              <div className="font-serif italic text-[#c43b3b] text-lg">{room.label}</div>
              <h3 className="font-serif text-xl text-[#1d1f24] mt-2 mb-2.5">{room.title}</h3>
              <p className="text-sm text-[#5d606a] leading-relaxed">{room.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
